// extracted by mini-css-extract-plugin
export var container = "IntroProductModal_container__llnPQ";
export var disclaimer = "IntroProductModal_disclaimer__r8Izg";
export var fontNunitoSans = "'Nunito Sans'";
export var fontPlayfair = "'PlayFair Display'";
export var shared = "'../shared.module.css'";
export var sm = "576px";
export var subtitle = "IntroProductModal_subtitle__RioDx";
export var textContainer = "IntroProductModal_textContainer__CJG4M";